import { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Grid,
} from "@mui/material";
import { CLIENTS, DATE_RANGES } from "../../../../data";

export default function ReportFilters({ filters, onChange }) {
  const [showCustomDates, setShowCustomDates] = useState(filters.dateRange === "custom");

  const handleDateRangeChange = (e) => {
    const value = e.target.value;
    setShowCustomDates(value === "custom");
    onChange({ ...filters, dateRange: value });
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
        Configure Report
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <TextField
            select
            fullWidth
            label="Select Client"
            value={filters.clientId || ""}
            onChange={(e) => onChange({ ...filters, clientId: e.target.value })}
          >
            <MenuItem value="">All Clients</MenuItem>
            {CLIENTS.map((client) => (
              <MenuItem key={client.id} value={client.id}>
                {client.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            select
            fullWidth
            label="Date Range"
            value={filters.dateRange || "last_month"}
            onChange={handleDateRangeChange}
          >
            {DATE_RANGES.map((range) => (
              <MenuItem key={range.id} value={range.id}>
                {range.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        {showCustomDates && (
          <>
            <Grid item xs={12} md={6}>
              <TextField
                type="date"
                fullWidth
                label="Start Date"
                InputLabelProps={{ shrink: true }}
                value={filters.startDate || ""}
                onChange={(e) => onChange({ ...filters, startDate: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                type="date"
                fullWidth
                label="End Date"
                InputLabelProps={{ shrink: true }}
                value={filters.endDate || ""}
                onChange={(e) => onChange({ ...filters, endDate: e.target.value })}
              />
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
}
